
import React from "react";
import { DateHelper } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import { useInView } from "../../hooks";
import StatCard from "../common/StatCard";
import { stripMarkdown } from "../../helpers";
import styles from "../../assets/style.module.css";
import { IHostWebsite } from "../../../../../services";

export interface AboutStatsProps {
    teamCount?: number;
    website: IHostWebsite;
}

function AboutStats({ website, teamCount }: AboutStatsProps) {

    const labels = i18nManager.Labels.home;
    const [ref, inView] = useInView();
    const created = website.host.created_at ? new Date(website.host.created_at) : undefined;
    const years = created ? Math.max(1, DateHelper.now().getFullYear() - created.getFullYear()) : 0;
    const stats = [
        { value: website.host.meta?.tournaments_count ?? 0, suffix: "+", label: labels.stat_tournaments },
        { value: website.host.meta?.countries?.length ?? 0, label: labels.stat_countries },
        { value: years, suffix: "+", label: labels.stat_years },
        { value: teamCount ?? 0, label: labels.stat_team },
    ].filter((s) => s.value > 0);
    const text = stripMarkdown(website.about_settings?.info || website.host.short_info, 260);

    if (!text && !stats.length) return null;

    return (<section className={styles["about"]}>
        <div className={styles["container"]}>
            <div className={styles["about-inner"]}>
                <span className={styles["tag"]}>{labels.who_we_are}</span>
                {text && (<p className={styles["h-03"]}>{text}</p>)}
            </div>
            {stats.length > 0 && (<div ref={ref} className={styles["stat-wrap"]}>
                {stats.map((s, i) => (<StatCard key={s.label} index={i} start={inView} {...s} />))}
            </div>)}
        </div>
    </section>);
}

export default AboutStats;
